import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FileService } from '../../services/file.service';
import { UtilsService } from '../../services/utils.service';
import * as _ from 'lodash';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-light-box',
  templateUrl: './light-box.component.html',
  styleUrls: ['./light-box.component.scss']
})
export class LightBoxComponent implements OnChanges {

  @Input('photos') photos: any[];
  @Input('idLabel') idLabel: string;
  @Input('id') id: string;
  @Input('totalCount') totalCount: number;
  @Output() photoChanged: EventEmitter<any> = new EventEmitter();
  @Output() addedToGallery?: EventEmitter<any> = new EventEmitter();
  @Output() addedToMeetTheLocals?: EventEmitter<any> = new EventEmitter();
  @Output() featuredImageChanged?: EventEmitter<any> = new EventEmitter();

  openedIndex = -1;
  photosCopy: any[];
  serverUri = environment.server

  constructor(private fileService: FileService, private utilsService: UtilsService) { }

  ngOnChanges(changes) {
    if (changes.photos) {
      this.photosCopy = _.cloneDeep(this.photos);
    }
  }
  openPhoto(index) {
    this.openedIndex = index;
  }

  closePhoto() {
    this.openedIndex = -1;
  }

  next() {
    this.openedIndex++;
    this.photoChanged.emit(this.openedIndex);
  }

  prev() {
    this.openedIndex--;
    this.photoChanged.emit(this.openedIndex);
  }

  updatePremiumPhoto(file) {
    const data = {
      imageId: file.id,
      premium: file.premium
    };
    this.fileService.updatePremiumFlag(data).subscribe(res => {
      const msg = file.premium ? 'Image marked as premium!!' : 'Image removed from premium';
      this.utilsService.openSnackBar(msg, '');
    }, err => {
      this.utilsService.openSnackBar('Error updating premium image!!', '');
    });
  }

  updatePrivatePhoto(file) {
    const data = {
      imageId: file.id,
      private: file.private
    };
    this.fileService.updatePrivateFlag(data).subscribe(res => {
      const msg = file.private ? 'Image marked as private!!' : 'Image removed from private';
      this.utilsService.openSnackBar(msg, '');
    }, err => {
      this.utilsService.openSnackBar('Error updating private image!!', '');
    });
  }

  downloadOriginalImage(file) {
    this.utilsService.getFile(file.originalUrl || file.url).subscribe((res) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res);
      a.download = `mb-file-${this.utilsService.generateRandomString()} + ${res.type.substring(6)}`;
      document.body.appendChild(a);
      a.click();
    });
  }
  downloadWaterMarkedImage(file, dark) {
  const obj = {
    id: file.id,
    markUrl: dark
      ? "https://dashboard.mybhutan.com/admin/assets/img/watermark/black.png"
      : "https://dashboard.mybhutan.com/admin/assets/img/watermark/white.png"
  };

  this.fileService.getWaterMarkedImage(obj).subscribe((res: any) => {
  if (!res.loading) {
    const photoData = res.data.photos;

    if (photoData.totalCount === 1 && photoData.edges.length > 0) {
      const fileNode = photoData.edges[0].node;
      this.utilsService.getFile(fileNode.waterMarkUrl).subscribe((fileBlob) => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(fileBlob);
        a.download = `mb-file-${this.utilsService.generateRandomString()}.${fileBlob.type.split('/')[1]}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a); // Cleanup
      });
    }
  }
});

}


  updateFile(file) {
    this.fileService.updateFile(file).subscribe((response) => {
      if (response.errors && response.errors.length > 0) {
        const errors = response.errors.map(err => err.message);
        this.utilsService.openSnackBar(errors, '');
      } else {
        this.utilsService.openSnackBar('file updated!!', '');
      }
    }, (error) => {
      this.utilsService.openSnackBar('Unable to upload file.', '');
      console.log('there was an error sending the query', error);
    });
  }

  getPhotoType(file): string {
    if (file.owned) return 'owned';
    if (file.licensed) return 'licensed';
    if (file.sublicenseable) return 'sublicenseable';
    return 'none'; // default fallback
  }

  setPhotoType(file, value: string): void {
    file.owned = value === 'owned';
    file.licensed = value === 'licensed';
    file.sublicenseable = value === 'sublicenseable';

    this.updateFile(file); // Notify backend of changes
  }

  addToMeetTheLocal(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.addToMeetTheLocal(data).subscribe(res => {
      this.addedToMeetTheLocals.emit(file);
      this.utilsService.openSnackBar('Meet the local added successfully!', '');
    }, err => {
      this.utilsService.openSnackBar('Error adding meet the local!', '');
    });
  }

 

  setAsFeaturedImage(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.setAsFeaturedImage(data).subscribe(res => {
      this.featuredImageChanged.emit(file)
      this.utilsService.openSnackBar('Featured Image updated successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error updating featured image!', '');
    });
  }
  addToGallery(file) {
    const data = {
      [this.idLabel]: this.id,
      idLabel: this.idLabel,
      imageId: file.id
    };
    this.fileService.addToGallery(data).subscribe(res => {
      this.addedToGallery.emit(file)
      this.utilsService.openSnackBar('Image added to Gallery Successfully!!', '');
    }, err => {
      this.utilsService.openSnackBar('Error adding image to Gallery!!', '');
    });
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/shared/light-box/light-box.component.ts